import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ServiceChargesClient } from "../../../../../../../../Wrap/Api/Charge/ServiceCharges";
import { DrawdownInstructionClient } from "../../../../../../../../Wrap/Api/Drawdown/DrawdownInstruction";
import { DrawdownRequestClient } from "../../../../../../../../Wrap/Api/Drawdown/DrawdownRequest";
import { ImmediateTaxFreeCashIncomeRequestClient } from "../../../../../../../../Wrap/Api/Drawdown/ImmediateTaxFreeCashIncomeRequest";
import { MinimumPaymentDateClient } from "../../../../../../../../Wrap/Api/Payments/MinimumPaymentDate";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DrawdownCalculationStoreDispatcher } from "../Store/Variable";
import { PaymentMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";


export class DrawdownCalculationAction {
    public static doCalculate(callback?) {
        if (callback) { callback(); }
    }

    public static postDrawdown(
        hiercharyId,
        model,
        callback,
        isIllHealth = false,
        isTakePensionBenefitsWizard = false,
        isEditRegulaerDrawdownWizard = false
    ) {
        const client = new DrawdownInstructionClient();
        DrawdownCalculationStoreDispatcher.dispatch({ actionType: ActionType.Loading, payload: true });
        const promise = client.post(hiercharyId, model, isTakePensionBenefitsWizard, isEditRegulaerDrawdownWizard, isIllHealth);
        promise.onSuccess((result) => {
            DrawdownCalculationStoreDispatcher.dispatch({ actionType: ActionType.Loading, payload: false });
            callback(result.Result);
        });
        promise.onError((error) => { });
    }

    public static validateRequestId(requestId: number, drawdownModel: DrawdownModel, isITFC: boolean, callback, subaccountHierarchyId: string, instructionOwnerHierarchyId: string) {
        const client = new DrawdownRequestClient();
        const promise = client.post(requestId, drawdownModel, isITFC, subaccountHierarchyId, instructionOwnerHierarchyId);
        promise.onSuccess((result) => {
            callback(result);
        });
        promise.onError((error) => {
            callback(error);
        });
    }

    public static validateITFCIncomeId(requestId: number, subAccountHierarchyId: string, callback) {
        const client = new ImmediateTaxFreeCashIncomeRequestClient();
        const promise = client.post(requestId, subAccountHierarchyId);
        promise.onSuccess((result) => {
            callback(result);
        });
        // TODO backend needs to finish handle error
        promise.onError((error) => {
            callback(error);
        });
    }

    public static getMinimumPaymentDate(subAccountHierarchyId: string, isCrystallisationDisinvestmentRequired: boolean, isIncomeDisinvestmentRequired: boolean, callback, paymentMethod?: string) {
        const client = new MinimumPaymentDateClient();
        const customerId = getQueryParameters()["customerid"];
        if (!paymentMethod) {
            paymentMethod = "BACS";
        }
        let promise = client.get(subAccountHierarchyId, JsonDateParser.toJsonDateNoOffset(new Date()), isCrystallisationDisinvestmentRequired, isIncomeDisinvestmentRequired, paymentMethod, customerId);
        promise.onSuccess((result) => {
            callback(result)
        });
        promise.onError((error) => {
            callback(error)
        });
    }

    public static getEstimatedPlatformChargeRate(subAccountHierarchyId: string, assumedCashHolding: number, callback) {
        const client = new ServiceChargesClient();
        let promise = client.get(subAccountHierarchyId, assumedCashHolding);
        promise.onSuccess((result) => {
            callback(result)
        });
        promise.onError((error) => {
            callback(error)
        });
    }

}
